import React from 'react';
import { isMobile } from 'react-device-detect';
import IconStar from 'assets/static/images/ic_star.svg';
import IconPhone from 'assets/static/images/ic_phone.png';
import 'components/SideBlock/ShipperInfo/ShipperInfo.scss';
import { t } from 'localization';
import IconDefAvatar from 'assets/static/images/ic_default_avatar.png';
import { Block } from 'components/Block';

export const ShipperInfo = (props) => {
  const { data } = props;
  const { driver } = data;
  if (!driver) return null;
  const {
    avatars = [],
    name,
    license_plate: licensePlate,
    driver_statistics: driverStatistics = {},
    phone,
    is_deleted: isDeleted,
  } = driver;
  const { average_rate: avgRate = 0 } = driverStatistics;
  return (
    <Block>
      <div className='shipper-info-container'>
        <div className='avatar'>
          <img src={isDeleted ? IconDefAvatar : avatars[0].value} alt='avatar-shipper' />
        </div>
        {isDeleted && (
          <div className='shipper-info-offline'>
            <span>{t('driver_is_offline')}</span>
          </div>
        )}
        {!isDeleted && (
          <div className='info'>
            <div className='shipper-name'>{`${name} (${t('driver')})`}</div>
            <div
              className={
                isMobile ? 'shipper-statistic-mobile' : 'shipper-statistic'
              }
            >
              <div className='rate'>
                <img src={IconStar} alt='avg star shipper' />
                <span>{avgRate}</span>
              </div>
              <div className='dot'>·</div>
              <div className='license'>{licensePlate}</div>
              {!isMobile && (
                <div className='phone'>
                  <img src={IconPhone} alt='phone shipper' />
                  <span>{phone}</span>
                </div>
              )}
            </div>
          </div>
        )}
        {!isDeleted && isMobile && (
          <div className='phone-mobile'>
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <a href={`tel:${phone}`}><img src={IconPhone} alt='phone shipper' /></a>
          </div>
        )}
      </div>
    </Block>
  );
};
